import { IModalElement } from "../service/modals";
import { modalsService } from "./init";

export class ExploreFortyFourModal implements IModalElement {
  public id = 'explore-fortyfour';
  private closeButton: HTMLElement;
  private clickListener: EventListenerOrEventListenerObject;

  public onInit() {
    this.closeButton = modalsService.content.querySelector('[data-close-modal]');

    this.closeButton.addEventListener('click', this.clickListener = () => {
      modalsService.close();
    });
  }

  public onDestroy() {
    this.closeButton.removeEventListener('click', this.clickListener);
  }
}